export default "__VITE_ASSET__DF5yRpLJ__"